import { ViewCompact } from '@mui/icons-material';
import {
    styled, Box, Typography,
} from '@mui/material';
import { TitledAppBar } from 'src/components/common/TitledAppBar';
import { GalleryUrlCard } from 'src/components/SetsPlayground/GalleryUrlCard';
import { SetsConfigCard } from 'src/components/SetsPlayground/SetsConfigCard';
import { SetsPlaygroundFooter } from 'src/components/SetsPlayground/SetsPlaygroundFooter';
import { CONTENT_MAX_WIDTH } from 'src/components/SetsPlayground/constants';
import { useSetsConfig } from 'src/hooks/useSetsConfig';
import { useEffect } from 'react';

const StyledContainer = styled(Box)(({ theme }) => ({
    padding: `0 ${theme.spacing(8)}`,
    paddingBottom: theme.spacing(12),
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    overflow: 'auto',
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
    width: '100%',
    maxWidth: CONTENT_MAX_WIDTH,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
}));

export const SetsPlaygroundPage = (): JSX.Element => {
    const {
        config,
        setConfig,
        updateSetPriority,
        addSet,
        deleteSet,
        updateSetName,
        updateSetDistribution,
        updateSetRanking,
        updateSetFilter,
        updateSetDesignPersonalizationContextId,
        galleryUrl,
        updateGalleryUrl,
        productKey,
        updateSetProductKey,
    } = useSetsConfig();

    useEffect(() => {
        const params = new URLSearchParams();

        if (config?.sets) {
            params.set('rawSets', JSON.stringify(config.sets));
        }
        if (galleryUrl) {
            params.set('galleryUrl', galleryUrl);
        }
        if (productKey) {
            params.set('productKey', productKey);
        }

        const newUrl = `${window.location.pathname}?${params.toString()}`;

        window.history.replaceState({}, '', newUrl);
    }, [galleryUrl, config, productKey]);

    return (
        <>
            <TitledAppBar title="Sets Playground" />
            <StyledContainer>
                <ContentWrapper>
                    {/* TODO: Determine if we want to show this header */}
                    {false && (
                    <Box alignItems="center" display="flex" flexDirection="column" gap={2}>
                        <Typography variant="h6">
                            <ViewCompact />
                            Sets Playground
                        </Typography>
                        <Typography color="text.secondary" variant="body2">
                            Configure and test set distributions, rankings, and filters for gallery experiences.
                            Generate shareable URLs to preview how your sets will appear in live galleries.
                        </Typography>
                    </Box>
                    )}
                    <GalleryUrlCard
                        galleryUrl={galleryUrl}
                        setConfig={setConfig}
                        onUrlChange={updateGalleryUrl}
                    />
                    <SetsConfigCard
                        config={config}
                        productKey={productKey}
                        onAddSet={addSet}
                        onConfigChange={setConfig}
                        onDeleteSet={deleteSet}
                        onSetDesignPersonalizationContextIdChange={updateSetDesignPersonalizationContextId}
                        onSetDistributionChange={updateSetDistribution}
                        onSetFilterChange={updateSetFilter}
                        onSetNameChange={updateSetName}
                        onSetPriorityChange={(index, priority): void => { updateSetPriority(index, priority); }}
                        onSetProductKeyChange={updateSetProductKey}
                        onSetRankingChange={(index, ranking): void => { updateSetRanking(index, ranking); }}
                    />
                </ContentWrapper>
            </StyledContainer>
            <SetsPlaygroundFooter config={config} galleryUrl={galleryUrl} productKey={productKey} />
        </>
    );
};
